import React from "react";
import NavBar from "../../components/common/NavBar";
import { TestInputContainer } from "./styled";
import { FormFieldWrapper } from "../../styled/common";
import { Controller, useFormContext } from "react-hook-form";
import { FORM_NAMES, FormTypes } from "./types";
import { Datepicker } from "../../components/common/FieldDatepicker/Datepicker";
import Input from "../../components/common/FieldInput";

function IVDocumentSelection() {
  const {
    // handleSubmit,
    register,
    // trigger,
    // setValue,
    formState,
    // watch,
    // getValues,
    control,
    // reset,
  } = useFormContext<FormTypes>();
  const {errors} = formState;
  return (
    <>
      <NavBar title="Verify yuor indetity" />
      <TestInputContainer>
        <FormFieldWrapper>
          <Controller
            name={FORM_NAMES.birthDate}
            rules={{
              required: true,
              validate: (value) => {
                if (!value) {
                  return true;
                }
              },
            }}
            control={control}
            render={({
              field: { onChange, ...restField },
              fieldState: { error },
            }) => (
              <Datepicker
                disabled={false}
                error={error?.message}
                label={"birth_date"}
                onChange={(value) => {
                  return onChange(value?.toString());
                }}
                {...restField}
              />
            )}
          />
        </FormFieldWrapper>
      </TestInputContainer>
      <TestInputContainer>
      <FormFieldWrapper>
      <Input
            label={'name'}
            placeholder={'enter_name'}
            {...register(FORM_NAMES.name, {
              required:true,
              // pattern: {
              //   value: '',
              //   message: 'cant_contain_number_and_symbols',
              // }, // validacion de regex especial
              maxLength: {
                value: 10,
                message: `the max lenght is 10`,
              },
            })}
            error={errors[FORM_NAMES.name]?.message}
            // disabled={isLoadingCustomForm}
            autoCorrect="off"
            spellCheck={false}
          />
      </FormFieldWrapper>
      </TestInputContainer>
    </>
  );
}

export { IVDocumentSelection };
